import { LocationStringMap } from '../../../util/index';
import { Http, Resource } from '../../models/index';
import { DebounceUseCase } from '../DebounceUseCase';
import { RequestResource } from './RequestResource';

export namespace GetResource {
    export interface Params<L extends string> {
        parent: Resource<L>;
        rel: L;
        search?: LocationStringMap;
        noLinkError?: boolean;
        queryParams?: object;
        useCache?: boolean;
    }
}

export class GetResource<L extends string, T> extends DebounceUseCase<
    GetResource.Params<L>,
    T | undefined
> {
    private requestResource: RequestResource<L, void, T>;

    constructor(http: Http) {
        super();
        this.requestResource = new RequestResource<L, void, T>(http);
    }

    protected debounceExecute(params: GetResource.Params<L>): Promise<T | undefined> {
        return this.requestResource.execute({
            method: 'GET',
            parent: params.parent,
            rel: params.rel,
            search: params.search,
            noLinkError: params.noLinkError,
            queryParams: params.queryParams
        });
    }
}
